(function () {
  const sections = document.querySelectorAll('[data-awol-section]');
  if (!sections.length) return;

  (function initCountdowns() {
    var widgets = document.querySelectorAll('[data-awol-countdown]');
    if (!widgets.length) return;
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick(el) {
      var target = new Date(el.dataset.awolCountdownTarget).getTime();
      if (isNaN(target)) return;
      var diff = Math.max(0, target - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var nodes = {
        d: el.querySelector('[data-awol-countdown-days]'),
        h: el.querySelector('[data-awol-countdown-hours]'),
        m: el.querySelector('[data-awol-countdown-mins]'),
        s: el.querySelector('[data-awol-countdown-secs]'),
      };
      if (nodes.d) nodes.d.textContent = pad(d);
      if (nodes.h) nodes.h.textContent = pad(h);
      if (nodes.m) nodes.m.textContent = pad(m);
      if (nodes.s) nodes.s.textContent = pad(s);
      if (diff === 0) {
        el.classList.add('is-expired');
        var expired = el.querySelector('[data-awol-countdown-expired]');
        var expiredText = el.querySelector('[data-awol-countdown-expired-text]');
        var msg = el.dataset.awolCountdownExpiredMessage;
        if (expiredText && msg) expiredText.textContent = msg;
        if (expired) expired.hidden = false;
      }
    }
    widgets.forEach(function (el) {
      tick(el);
      setInterval(function () { tick(el); }, 1000);
    });
  })();

  document.documentElement.classList.add('js');
  document.body.classList.add('awol-template-active');

  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SCORE_STORAGE_KEY = 'wfsf-field-ops-highscores';
  const LEVELS = [
    {
      title: 'Perimeter check',
      mission: 'Level 1 // Perimeter',
      clearTitle: 'Perimeter cleared',
      clearCopy: 'You are approaching AWOL. Take free shipping or keep pushing.',
      playerX: 0.15,
      enemyX: 0.84,
      enemyHealth: 80,
      enemyDamage: 34,
      enemyBlast: 40,
      enemyPowerMin: 36,
      enemyPowerMax: 74,
      enemySpread: 15,
      windMax: 9,
      terrain: { base: 0.72, wave: 2.2, phase: 0.4, roll: 0.05, ridge: 5.4, ridgePhase: 0.7, ridgeRoll: 0.035, mound: 0.09, moundCenter: 0.52, moundWidth: 3.2 },
      skyTop: '#cfe8ff',
      skyBottom: '#9fd1ff',
      hillA: '#76b600',
      hillB: '#4d8d00',
    },
    {
      title: 'Off route',
      mission: 'Level 2 // Supply ridge',
      clearTitle: 'Route abandoned',
      clearCopy: 'Formation is breaking. The signal keeps saying AWOL.',
      playerX: 0.1,
      enemyX: 0.78,
      enemyHealth: 105,
      enemyDamage: 44,
      enemyBlast: 46,
      enemyPowerMin: 42,
      enemyPowerMax: 82,
      enemySpread: 11,
      windMax: 12,
      terrain: { base: 0.68, wave: 3.1, phase: 1.2, roll: 0.075, ridge: 7.2, ridgePhase: 0.2, ridgeRoll: 0.045, mound: 0.04, moundCenter: 0.38, moundWidth: 4.8 },
      skyTop: '#badfff',
      skyBottom: '#81c7f7',
      hillA: '#68a900',
      hillB: '#3f7c00',
    },
    {
      title: 'Radio silence',
      mission: 'Level 3 // Broken valley',
      clearTitle: 'Radio silence',
      clearCopy: 'No check-ins. No map. Only the AWOL route left.',
      playerX: 0.22,
      enemyX: 0.9,
      enemyHealth: 125,
      enemyDamage: 54,
      enemyBlast: 52,
      enemyPowerMin: 48,
      enemyPowerMax: 88,
      enemySpread: 8,
      windMax: 15,
      terrain: { base: 0.74, wave: 4.3, phase: 0.9, roll: 0.085, ridge: 8.7, ridgePhase: 1.4, ridgeRoll: 0.055, mound: -0.05, moundCenter: 0.55, moundWidth: 4.2 },
      skyTop: '#bfd0db',
      skyBottom: '#88b9d4',
      hillA: '#5c8d16',
      hillB: '#305f13',
    },
    {
      title: 'Final breach',
      mission: 'Level 4 // Go AWOL',
      clearTitle: 'Completely AWOL',
      clearCopy: 'You ran the table. Whole order goes AWOL at 20% off.',
      playerX: 0.08,
      enemyX: 0.92,
      enemyHealth: 150,
      enemyDamage: 64,
      enemyBlast: 58,
      enemyPowerMin: 54,
      enemyPowerMax: 92,
      enemySpread: 5,
      windMax: 18,
      terrain: { base: 0.7, wave: 5.2, phase: 1.9, roll: 0.095, ridge: 10.5, ridgePhase: 0.6, ridgeRoll: 0.065, mound: 0.12, moundCenter: 0.5, moundWidth: 2.4 },
      skyTop: '#9fb3c1',
      skyBottom: '#6fa7c9',
      hillA: '#6c850d',
      hillB: '#283f10',
    },
  ];

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function randomWind(level) {
    const limit = level && level.windMax ? level.windMax : 14;
    return Math.round((Math.random() * limit * 2 - limit) * 10) / 10;
  }

  function scoreDate() {
    return new Date().toISOString().slice(0, 10);
  }

  function loadScores() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(SCORE_STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((entry) => ({
          initials: String(entry.initials || 'WFSF').slice(0, 3).toUpperCase(),
          score: Number(entry.score) || 0,
          date: String(entry.date || scoreDate()).slice(0, 10),
        }))
        .filter((entry) => entry.score > 0)
        .sort((a, b) => b.score - a.score)
        .slice(0, 5);
    } catch (error) {
      return [];
    }
  }

  function saveScore(initials, score) {
    const cleanInitials = String(initials || 'WFSF').replace(/[^a-z0-9]/gi, '').slice(0, 3).toUpperCase() || 'WFS';
    const cleanScore = Math.max(0, Math.round(Number(score) || 0));
    const scores = loadScores();
    scores.push({ initials: cleanInitials, score: cleanScore, date: scoreDate() });
    const nextScores = scores.sort((a, b) => b.score - a.score).slice(0, 5);
    try {
      window.localStorage.setItem(SCORE_STORAGE_KEY, JSON.stringify(nextScores));
    } catch (error) {}
    return nextScores;
  }

  function isHighScore(score) {
    const cleanScore = Math.max(0, Math.round(Number(score) || 0));
    const scores = loadScores();
    return cleanScore > 0 && (scores.length < 5 || cleanScore > scores[scores.length - 1].score);
  }

  function syncHeaderCartCount(count) {
    if (count === undefined || count === null) return;
    document.querySelectorAll('[data-awol-cart-count]').forEach((element) => {
      element.textContent = String(count);
    });

    document.querySelectorAll('#wfsf-header.wfsf-header--awol a[href="/cart"], #wfsf-header.wfsf-header--awol a[href*="/cart"]').forEach((link) => {
      link.textContent = 'BAG (' + count + ')';
    });
  }

  function refreshCartCount() {
    const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    fetch(cartUrl + '.js')
      .then((response) => response.json())
      .then((cart) => syncHeaderCartCount(cart.item_count))
      .catch(() => {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      refreshCartCount();
    });
  }

  function initProductFilters(section) {
    const filters = Array.from(section.querySelectorAll('[data-awol-filter]'));
    if (!filters.length) return;

    const cards = Array.from(section.querySelectorAll('[data-awol-garment-card]'));
    const summary = section.querySelector('[data-awol-filter-summary]');
    const remainingGroups = Array.from(section.querySelectorAll('.awol-supply__remaining'));
    const labels = {
      all: 'AWOL field supply',
      new: 'new issue pieces',
      sets: 'set pieces',
      womens: "women's tees",
      tees: 'tees and tops',
      tanks: 'tanks',
      shorts: 'shorts',
      accessories: 'accessories',
    };

    function applyFilter(value) {
      const activeValue = value || 'all';
      let visibleCount = 0;

      cards.forEach((card) => {
        const categories = (card.dataset.awolCategory || 'all').split(/\s+/);
        const shouldShow = activeValue === 'all' || categories.indexOf(activeValue) !== -1;
        card.classList.toggle('is-filter-hidden', !shouldShow);
        if (shouldShow) visibleCount += 1;
      });

      filters.forEach((filter) => {
        const isActive = filter.dataset.awolFilter === activeValue;
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      remainingGroups.forEach((group) => {
        const hasVisibleCards = Array.from(group.querySelectorAll('[data-awol-garment-card]')).some((card) => !card.classList.contains('is-filter-hidden'));
        group.hidden = activeValue !== 'all' && !hasVisibleCards;
      });

      if (summary) {
        summary.textContent = activeValue === 'all'
          ? 'Showing all AWOL field supply.'
          : 'Showing ' + visibleCount + ' ' + (labels[activeValue] || 'items') + '.';
      }
    }

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        applyFilter(filter.dataset.awolFilter || 'all');
      });
    });

    applyFilter('all');
  }

  sections.forEach((section) => {
    initProductFilters(section);

    const game = section.querySelector('[data-awol-game]');
    const canvas = section.querySelector('[data-awol-yard-canvas]');
    const playButton = section.querySelector('[data-awol-play-game]');
    const startButton = section.querySelector('[data-awol-start-game]');
    const playAgainButton = section.querySelector('[data-awol-play-again]');
    const fireButtons = Array.from(section.querySelectorAll('[data-awol-fire]'));
    const status = section.querySelector('[data-awol-status]');
    const levelOutput = section.querySelector('[data-awol-level]');
    const scoreOutput = section.querySelector('[data-awol-score]');
    const bestOutput = section.querySelector('[data-awol-best]');
    const angleOutput = section.querySelector('[data-awol-angle]');
    const powerInput = section.querySelector('[data-awol-power]');
    const powerOutput = section.querySelector('[data-awol-power-readout]');
    const weaponInput = section.querySelector('[data-awol-weapon]');
    const playerHealthMeter = section.querySelector('[data-awol-player-health]');
    const playerHealthText = section.querySelector('[data-awol-player-health-text]');
    const enemyHealthText = section.querySelector('[data-awol-enemy-health-text]');
    const celebration = section.querySelector('[data-awol-celebration]');
    const celebrationKicker = section.querySelector('[data-awol-celebration-kicker]');
    const celebrationTitle = section.querySelector('[data-awol-celebration-title]');
    const celebrationCopy = section.querySelector('[data-awol-celebration-copy]');
    const rewardCode = section.querySelector('[data-awol-reward-code]');
    const rewardLink = section.querySelector('[data-awol-reward-link]');
    const rewardCopyButton = section.querySelector('[data-awol-copy-reward]');
    const continueButton = section.querySelector('[data-awol-continue]');
    const clearanceCard = section.querySelector('[data-awol-clearance]');
    const clearanceDate = section.querySelector('[data-awol-clearance-date]');
    const clearanceScore = section.querySelector('[data-awol-clearance-score]');
    const clearanceBest = section.querySelector('[data-awol-clearance-best]');
    const clearanceCode = section.querySelector('[data-awol-clearance-code]');
    const highScoresPanel = section.querySelector('[data-awol-highscores]');
    const highScoreForm = section.querySelector('[data-awol-score-form]');
    const highScoreInitials = section.querySelector('[data-awol-score-initials]');
    const highScoreRows = section.querySelector('[data-awol-score-rows]');
    const highScorePlayAgain = section.querySelector('[data-awol-score-play-again]');
    const aimButtons = Array.from(section.querySelectorAll('[data-awol-aim]'));
    const driveButtons = Array.from(section.querySelectorAll('[data-awol-drive]'));
    const cards = Array.from(section.querySelectorAll('[data-awol-garment-card]'));
    const freeShippingCode = game && game.dataset.awolFreeShippingCode ? game.dataset.awolFreeShippingCode : 'WFSFSHIP';
    const finalRewardCode = game && game.dataset.awolFinalRewardCode ? game.dataset.awolFinalRewardCode : 'WFSF20';
    const cartUrl = game && game.dataset.awolCartUrl ? game.dataset.awolCartUrl : '/cart';
    let activeRewardCode = '';

    if (!canvas) return;

    const context = canvas.getContext('2d');
    if (!context) return;

    const logo = {
      image: new Image(),
      ready: false,
      src: canvas.dataset.awolLogoSrc || '',
    };

    if (logo.src) {
      logo.image.onload = () => {
        logo.ready = true;
        drawGame();
      };
      logo.image.src = logo.src;
    }

    const state = {
      playing: false,
      phase: 'ready',
      angle: 45,
      enemyAngle: 45,
      power: Number(powerInput ? powerInput.value : 54),
      wind: 0,
      score: 0,
      round: 1,
      level: 1,
      playerHealth: 100,
      enemyHealth: 100,
      activeCard: 0,
      tankX: 0.16,
      enemyX: 0.84,
      playerShots: 0,
      projectiles: [],
      shotSequence: 0,
      explosion: null,
      craters: [],
      lastFrame: 0,
      raf: 0,
      draggingAim: false,
    };
    let enemyTimer = 0;

    function setStatus(text) {
      if (status) status.textContent = text;
    }

    function currentLevel() {
      return LEVELS[clamp(state.level, 1, LEVELS.length) - 1] || LEVELS[0];
    }

    function discountUrl(code) {
      return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
    }

    function renderBestScore() {
      const best = loadScores()[0];
      if (bestOutput) bestOutput.textContent = best ? String(best.score) : '0';
    }

    function renderHighScores() {
      if (!highScoreRows) return;
      highScoreRows.innerHTML = '';
      const scores = loadScores();
      for (let index = 0; index < 5; index += 1) {
        const entry = scores[index];
        const row = document.createElement('tr');
        const rank = document.createElement('td');
        const initials = document.createElement('td');
        const score = document.createElement('td');
        const date = document.createElement('td');

        rank.textContent = String(index + 1);
        initials.textContent = entry ? entry.initials : '---';
        score.textContent = entry ? String(entry.score) : '0';
        date.textContent = entry ? entry.date : '----';

        row.append(rank, initials, score, date);
        highScoreRows.appendChild(row);
      }
    }

    function hideHighScores() {
      if (highScoresPanel) highScoresPanel.hidden = true;
      if (highScoreForm) highScoreForm.hidden = true;
      if (highScoreInitials) highScoreInitials.value = '';
      if (highScorePlayAgain) highScorePlayAgain.hidden = true;
    }

    function showHighScores() {
      if (!highScoresPanel) return;
      const qualifies = isHighScore(state.score);
      renderHighScores();
      highScoresPanel.hidden = false;

      if (highScoreForm) highScoreForm.hidden = !qualifies;
      if (highScorePlayAgain) highScorePlayAgain.hidden = qualifies;
      if (qualifies && highScoreInitials) {
        highScoreInitials.value = '';
        window.setTimeout(() => highScoreInitials.focus(), 0);
      }
    }

    function clearanceStamp() {
      const now = new Date();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const year = String(now.getFullYear()).slice(-2);
      return month + '.' + day + '.' + year;
    }

    function hideClearance() {
      if (clearanceCard) clearanceCard.hidden = true;
    }

    function showClearance(code) {
      if (!clearanceCard) return;
      const best = loadScores()[0];
      const bestScore = Math.max(state.score, best ? best.score : 0);
      if (clearanceDate) clearanceDate.textContent = clearanceStamp();
      if (clearanceScore) clearanceScore.textContent = String(state.score);
      if (clearanceBest) clearanceBest.textContent = String(bestScore);
      if (clearanceCode) clearanceCode.textContent = code || finalRewardCode;
      clearanceCard.hidden = false;
    }

    function hideCelebration() {
      activeRewardCode = '';
      if (celebration) celebration.hidden = true;
      hideClearance();
      hideHighScores();
      if (rewardCode) {
        rewardCode.hidden = true;
        rewardCode.textContent = '';
      }
      if (rewardLink) rewardLink.hidden = true;
      if (rewardCopyButton) {
        rewardCopyButton.hidden = true;
        rewardCopyButton.textContent = 'Copy code';
      }
      if (continueButton) continueButton.hidden = true;
    }

    function burstConfetti() {
      if (!celebration || prefersReducedMotion) return;
      const colors = ['#f8ff4f', '#ff6b12', '#dc1919', '#173b74', '#a6ff00', '#ffffff'];
      for (let index = 0; index < 26; index += 1) {
        const piece = document.createElement('span');
        piece.className = 'awol-confetti';
        piece.style.setProperty('--x', Math.round(Math.random() * 360 - 180) + 'px');
        piece.style.setProperty('--y', Math.round(Math.random() * 180 + 120) + 'px');
        piece.style.setProperty('--rotate', Math.round(Math.random() * 540 - 270) + 'deg');
        piece.style.setProperty('--duration', Math.round(Math.random() * 420 + 900) + 'ms');
        piece.style.setProperty('--color', colors[index % colors.length]);
        celebration.appendChild(piece);
        window.setTimeout(() => {
          piece.remove();
        }, 1500);
      }
    }

    function showCelebration(options) {
      const settings = options || {};
      const level = currentLevel();
      if (!celebration) return;
      if (settings.showScores) showPlayAgain(false);
      activeRewardCode = settings.code || '';
      if (celebrationKicker) celebrationKicker.textContent = settings.kicker || 'Level clear';
      if (celebrationTitle) celebrationTitle.textContent = settings.title || level.clearTitle;
      if (celebrationCopy) celebrationCopy.textContent = settings.copy || level.clearCopy;

      if (rewardCode) {
        rewardCode.hidden = !activeRewardCode || Boolean(settings.showClearance);
        rewardCode.textContent = activeRewardCode;
      }

      if (rewardLink) {
        rewardLink.hidden = !activeRewardCode;
        if (activeRewardCode) {
          rewardLink.href = discountUrl(activeRewardCode);
          rewardLink.textContent = settings.rewardLabel || 'Claim reward';
        }
      }

      if (rewardCopyButton) {
        rewardCopyButton.hidden = !activeRewardCode;
        rewardCopyButton.textContent = 'Copy code';
      }

      if (continueButton) {
        continueButton.hidden = !settings.canContinue;
        continueButton.textContent = settings.continueLabel || 'Advance';
      }

      if (settings.showScores) {
        showHighScores();
      } else {
        hideHighScores();
      }

      if (settings.showClearance) {
        showClearance(activeRewardCode);
      } else {
        hideClearance();
      }

      celebration.hidden = false;
      burstConfetti();
    }

    function setControlsDisabled(disabled) {
      fireButtons.forEach((button) => {
        button.disabled = disabled;
      });
      aimButtons.forEach((button) => {
        button.disabled = disabled;
      });
      driveButtons.forEach((button) => {
        button.disabled = disabled;
      });
      if (powerInput) powerInput.disabled = disabled;
      if (weaponInput) weaponInput.disabled = disabled;
    }

    function showPlayAgain(show) {
      if (!playAgainButton) return;
      playAgainButton.hidden = !show;
    }

    function syncHud() {
      renderBestScore();
      if (levelOutput) levelOutput.textContent = state.level + '/' + LEVELS.length;
      if (angleOutput) angleOutput.textContent = Math.round(state.angle) + ' deg';
      if (powerOutput) powerOutput.textContent = Math.round(state.power);
      if (powerInput && Number(powerInput.value) !== Math.round(state.power)) {
        powerInput.value = String(Math.round(state.power));
      }
      if (scoreOutput) scoreOutput.textContent = String(state.score);
      if (playerHealthMeter) playerHealthMeter.value = state.playerHealth;
      if (playerHealthText) playerHealthText.textContent = String(Math.round(state.playerHealth));
      if (enemyHealthText) enemyHealthText.textContent = String(Math.round(state.enemyHealth));

      const controlsLocked = state.phase === 'enemy' || state.phase === 'level-clear' || state.phase === 'won' || state.phase === 'lost' || state.projectiles.length > 0;
      setControlsDisabled(controlsLocked);
      showPlayAgain(state.phase === 'won' || state.phase === 'lost');
    }

    function setActiveCard(index) {
      if (!cards.length) return;
      state.activeCard = ((index % cards.length) + cards.length) % cards.length;
      cards.forEach((card, cardIndex) => {
        card.classList.toggle('is-active', cardIndex === state.activeCard);
      });
    }

    function startRound(options) {
      const settings = options || {};
      if (settings.resetCampaign) {
        state.level = 1;
        state.score = 0;
      }
      if (settings.level) state.level = clamp(settings.level, 1, LEVELS.length);
      const level = currentLevel();
      state.playing = true;
      state.phase = 'player';
      if (settings.resetScore) state.score = 0;
      state.playerHealth = 100;
      state.enemyHealth = level.enemyHealth;
      state.enemyAngle = 45;
      state.playerShots = 0;
      state.wind = randomWind(level);
      state.projectiles = [];
      state.explosion = null;
      state.craters = [];
      state.tankX = level.playerX;
      state.enemyX = level.enemyX;
      state.draggingAim = false;
      window.clearTimeout(enemyTimer);
      hideCelebration();
      section.classList.add('is-game-live');
      setStatus(level.title);
      syncHud();
      drawGame();
    }

    function fitCanvas() {
      const rect = canvas.getBoundingClientRect();
      const scale = window.devicePixelRatio || 1;
      canvas.width = Math.max(1, Math.floor(rect.width * scale));
      canvas.height = Math.max(1, Math.floor(rect.height * scale));
      context.setTransform(scale, 0, 0, scale, 0, 0);
      drawGame();
    }

    function baseTerrainY(x, width, height) {
      const level = currentLevel();
      const terrain = level.terrain;
      const ratio = x / width;
      const rolling = Math.sin(ratio * Math.PI * terrain.wave - terrain.phase) * terrain.roll;
      const ridges = Math.sin(ratio * Math.PI * terrain.ridge + terrain.ridgePhase) * terrain.ridgeRoll;
      const mound = Math.exp(-Math.pow((ratio - terrain.moundCenter) * terrain.moundWidth, 2)) * terrain.mound;
      return height * (terrain.base - rolling - ridges - mound);
    }

    function terrainY(x, width, height) {
      let y = baseTerrainY(x, width, height);
      state.craters.forEach((crater) => {
        const distance = Math.abs(x - crater.x);
        if (distance < crater.radius) {
          const falloff = 1 - distance / crater.radius;
          y += crater.depth * falloff * falloff;
        }
      });
      return clamp(y, height * 0.34, height * 0.92);
    }

    function tankPosition(side) {
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const ratio = side === 'enemy' ? state.enemyX : state.tankX;
      const x = width * ratio;
      return { x, y: terrainY(x, width, height) };
    }

    function drawCloud(x, y, scale) {
      context.fillStyle = 'rgba(255, 255, 255, 0.9)';
      context.beginPath();
      context.arc(x, y, 18 * scale, 0, Math.PI * 2);
      context.arc(x + 22 * scale, y - 7 * scale, 23 * scale, 0, Math.PI * 2);
      context.arc(x + 48 * scale, y, 18 * scale, 0, Math.PI * 2);
      context.rect(x - 4 * scale, y, 58 * scale, 18 * scale);
      context.fill();
    }

    function drawHill(points, fill) {
      context.fillStyle = fill;
      context.beginPath();
      context.moveTo(points[0][0], points[0][1]);
      points.slice(1).forEach((point) => context.lineTo(point[0], point[1]));
      context.closePath();
      context.fill();
    }

    function drawImageContain(image, x, y, width, height) {
      const imageRatio = image.naturalWidth / image.naturalHeight;
      const targetRatio = width / height;
      let renderWidth = width;
      let renderHeight = height;
      let renderX = x;
      let renderY = y;

      if (imageRatio > targetRatio) {
        renderHeight = width / imageRatio;
        renderY = y + (height - renderHeight) / 2;
      } else {
        renderWidth = height * imageRatio;
        renderX = x + (width - renderWidth) / 2;
      }

      context.drawImage(image, renderX, renderY, renderWidth, renderHeight);
    }

    function drawSmallBrandFlag(width, height) {
      if (!logo.ready) return;

      const x = width * 0.1;
      const y = terrainY(width * 0.1, width, height) - 58;
      context.save();
      context.strokeStyle = '#0c1605';
      context.lineWidth = 2;
      context.beginPath();
      context.moveTo(x, y);
      context.lineTo(x, y + 48);
      context.stroke();

      context.fillStyle = '#163566';
      context.beginPath();
      context.moveTo(x + 3, y + 4);
      context.lineTo(x + 48, y);
      context.lineTo(x + 44, y + 25);
      context.lineTo(x + 5, y + 29);
      context.closePath();
      context.fill();
      context.stroke();

      context.beginPath();
      context.moveTo(x + 3, y + 4);
      context.lineTo(x + 48, y);
      context.lineTo(x + 44, y + 25);
      context.lineTo(x + 5, y + 29);
      context.closePath();
      context.clip();
      drawImageContain(logo.image, x + 9, y + 8, 31, 14);
      context.restore();
    }

    function drawPlayerLabel(x, y, align, label, color, scale) {
      context.save();
      context.textAlign = align;
      context.textBaseline = 'top';
      context.font = '900 ' + Math.round(38 * scale) + 'px Impact, Arial Black, sans-serif';
      context.lineWidth = Math.max(2, 3 * scale);
      context.strokeStyle = 'rgba(255, 255, 255, 0.86)';
      context.fillStyle = color;
      context.strokeText(label, x, y);
      context.fillText(label, x, y);
      context.restore();
    }

    function drawPineTree(x, y, scale) {
      context.save();
      context.translate(x, y);
      context.scale(scale, scale);
      context.fillStyle = 'rgba(47, 104, 0, 0.42)';
      context.fillRect(-3, 12, 6, 22);
      context.beginPath();
      context.moveTo(0, -30);
      context.lineTo(-20, 10);
      context.lineTo(20, 10);
      context.closePath();
      context.fill();
      context.beginPath();
      context.moveTo(0, -10);
      context.lineTo(-24, 28);
      context.lineTo(24, 28);
      context.closePath();
      context.fill();
      context.restore();
    }

    function launchAngleFor(owner) {
      const degrees = owner === 'enemy' ? state.enemyAngle : state.angle;
      return (degrees * Math.PI) / 180;
    }

    function drawTank(x, y, side, active) {
      const direction = side === 'left' ? 1 : -1;
      const tankScale = clamp(canvas.clientWidth / 1200, 0.34, 0.65);
      const bodyColor = side === 'left' ? '#3c5b2c' : '#77714f';
      const trim = side === 'left' ? '#edf7da' : '#b7af77';
      const turret = side === 'left' ? '#213b18' : '#4a4430';

      context.save();
      context.translate(x, y);
      context.scale(direction * tankScale, tankScale);

      context.lineJoin = 'round';
      context.lineCap = 'round';
      context.strokeStyle = active ? '#ffef44' : '#0c1605';
      context.lineWidth = active ? 5 : 3;

      context.fillStyle = '#0c1605';
      context.beginPath();
      context.roundRect(-46, -15, 92, 18, 7);
      context.fill();
      context.stroke();

      context.fillStyle = '#617048';
      for (let wheel = -34; wheel <= 34; wheel += 17) {
        context.beginPath();
        context.arc(wheel, -5, 7, 0, Math.PI * 2);
        context.fill();
        context.strokeStyle = '#0c1605';
        context.stroke();
      }

      context.fillStyle = bodyColor;
      context.beginPath();
      context.moveTo(-36, -15);
      context.lineTo(-25, -36);
      context.lineTo(22, -38);
      context.lineTo(42, -18);
      context.lineTo(30, -13);
      context.closePath();
      context.fill();
      context.strokeStyle = '#0c1605';
      context.stroke();

      context.fillStyle = trim;
      context.beginPath();
      context.roundRect(-6, -46, 34, 13, 4);
      context.fill();
      context.stroke();

      context.fillStyle = turret;
      context.beginPath();
      context.roundRect(-24, -34, 42, 19, 4);
      context.fill();
      context.stroke();

      const barrelAngle = side === 'left' ? -launchAngleFor('player') : -launchAngleFor('enemy');
      context.rotate(barrelAngle);
      context.fillStyle = '#0c1605';
      context.fillRect(12, -3, 54, 6);
      context.fillStyle = bodyColor;
      context.fillRect(62, -5, 12, 10);

      context.restore();
    }

    function drawTerrain(width, height) {
      context.fillStyle = '#6db000';
      context.beginPath();
      context.moveTo(0, height);
      for (let x = 0; x <= width + 8; x += 8) {
        context.lineTo(x, terrainY(x, width, height));
      }
      context.lineTo(width, height);
      context.closePath();
      context.fill();

      context.fillStyle = 'rgba(47, 104, 0, 0.24)';
      for (let x = 0; x < width; x += 34) {
        const y = terrainY(x, width, height);
        context.fillRect(x, y + 22, 3, height - y);
      }
    }

    function drawWind(width) {
      const centerX = width * 0.5;
      const compact = width < 560;
      const top = compact ? 112 : 28;
      const windWidth = compact ? 94 : 112;
      context.fillStyle = 'rgba(255, 255, 255, 0.72)';
      context.fillRect(centerX - windWidth / 2, top - 14, windWidth, 23);
      context.strokeStyle = '#8aa3bf';
      context.strokeRect(centerX - windWidth / 2, top - 14, windWidth, 23);
      context.fillStyle = '#0c1605';
      context.font = '900 11px Courier New, monospace';
      const label = 'wind ' + (state.wind > 0 ? '+' : '') + state.wind.toFixed(1);
      context.fillText(label, centerX - windWidth / 2 + 12, top + 2);
    }

    function drawMissionStamp(width, height) {
      const level = currentLevel();
      const compact = width < 560;
      const stampWidth = compact ? Math.min(182, width * 0.44) : width * 0.32;
      const stampX = width * 0.5 - stampWidth / 2;
      const stampTop = compact ? 76 : height * 0.08;
      context.save();
      context.fillStyle = 'rgba(255, 249, 199, 0.72)';
      context.strokeStyle = 'rgba(12, 22, 5, 0.45)';
      context.lineWidth = 1;
      context.fillRect(stampX, stampTop, stampWidth, 30);
      context.strokeRect(stampX, stampTop, stampWidth, 30);
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillStyle = level.title === 'Final breach' ? '#a82a24' : '#173b74';
      context.font = '900 ' + Math.round(clamp(width / 62, 12, 20)) + 'px Courier New, monospace';
      context.fillText(level.title + ' // ' + state.level + '/' + LEVELS.length, width * 0.5, stampTop + 15);
      context.restore();
    }

    function drawCanvasHud(width) {
      const boxWidth = Math.min(178, width * 0.36);
      const boxHeight = 56;
      const top = 12;

      function drawBox(x, title, lines, accent) {
        context.save();
        context.fillStyle = 'rgba(249, 251, 255, 0.76)';
        context.strokeStyle = 'rgba(12, 22, 5, 0.72)';
        context.lineWidth = 2;
        context.fillRect(x, top, boxWidth, boxHeight);
        context.strokeRect(x, top, boxWidth, boxHeight);
        context.fillStyle = accent;
        context.font = '900 12px Courier New, monospace';
        context.fillText(title, x + 9, top + 17);
        context.fillStyle = '#0c1605';
        context.font = '900 11px Courier New, monospace';
        lines.forEach((line, index) => {
          context.fillText(line, x + 9, top + 34 + index * 14);
        });
        context.restore();
      }

      drawBox(12, 'PLAYER 1', ['LV ' + state.level + '/' + LEVELS.length, 'HP ' + Math.round(state.playerHealth)], '#173b74');
      drawBox(width - boxWidth - 12, 'OPPOSITION', ['HP ' + Math.round(state.enemyHealth), 'FIELD ' + state.level], '#a82a24');
    }

    function drawProjectile() {
      state.projectiles.forEach((projectile) => {
        if (projectile.trail && projectile.trail.length > 1) {
          context.save();
          context.strokeStyle = projectile.owner === 'enemy' ? 'rgba(220, 25, 25, 0.78)' : 'rgba(12, 22, 5, 0.46)';
          context.lineWidth = projectile.radius * 1.7;
          context.lineCap = 'round';
          context.beginPath();
          projectile.trail.forEach((point, index) => {
            if (index === 0) context.moveTo(point.x, point.y);
            else context.lineTo(point.x, point.y);
          });
          context.stroke();
          context.restore();
        }

        context.save();
        if (projectile.drawChute && projectile.vy > 0) {
          context.strokeStyle = '#173b74';
          context.fillStyle = 'rgba(233, 244, 255, 0.92)';
          context.lineWidth = 2;
          context.beginPath();
          context.arc(projectile.x, projectile.y - 18, 13, Math.PI, Math.PI * 2);
          context.closePath();
          context.fill();
          context.stroke();
          context.beginPath();
          context.moveTo(projectile.x - 9, projectile.y - 17);
          context.lineTo(projectile.x - 2, projectile.y - 4);
          context.moveTo(projectile.x + 9, projectile.y - 17);
          context.lineTo(projectile.x + 2, projectile.y - 4);
          context.stroke();
        }
        context.fillStyle = projectile.owner === 'enemy' ? '#dc1919' : projectile.weapon === 'supply' ? '#178dff' : projectile.weapon === 'volcano-child' ? '#ff6b12' : '#0c1605';
        context.beginPath();
        context.arc(projectile.x, projectile.y, projectile.radius, 0, Math.PI * 2);
        context.fill();
        context.restore();
      });
    }

    function drawExplosion() {
      if (!state.explosion) return;
      const alpha = Math.max(0, state.explosion.life / 30);
      context.save();
      context.globalAlpha = alpha;
      context.fillStyle = '#ffef44';
      context.beginPath();
      context.arc(state.explosion.x, state.explosion.y, state.explosion.radius, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = '#ff6b12';
      context.beginPath();
      context.arc(state.explosion.x, state.explosion.y, state.explosion.radius * 0.62, 0, Math.PI * 2);
      context.fill();
      context.restore();
    }

    function drawGame() {
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      if (!width || !height) return;
      const level = currentLevel();

      const sky = context.createLinearGradient(0, 0, 0, height * 0.62);
      sky.addColorStop(0, level.skyTop);
      sky.addColorStop(1, level.skyBottom);
      context.fillStyle = sky;
      context.fillRect(0, 0, width, height);

      context.fillStyle = 'rgba(255, 252, 128, 0.82)';
      context.beginPath();
      context.arc(width * 0.82, height * 0.18, Math.min(width, height) * 0.09, 0, Math.PI * 2);
      context.fill();

      drawCloud(width * 0.08, height * 0.16, width < 500 ? 0.7 : 1.2);
      drawCloud(width * 0.27, height * 0.34, width < 500 ? 0.5 : 0.8);
      drawCloud(width * 0.64, height * 0.17, width < 500 ? 0.65 : 1.35);

      drawHill([
        [0, height * 0.62],
        [width * 0.12, height * 0.34],
        [width * 0.26, height * 0.66],
        [width * 0.48, height * 0.31],
        [width * 0.67, height * 0.64],
        [width * 0.86, height * 0.36],
        [width, height * 0.58],
        [width, height],
        [0, height],
      ], level.hillA);

      drawHill([
        [0, height * 0.66],
        [width * 0.14, height * 0.47],
        [width * 0.22, height * 0.66],
        [width * 0.5, height * 0.47],
        [width * 0.62, height * 0.65],
        [width * 0.86, height * 0.48],
        [width, height * 0.62],
        [width, height],
        [0, height],
      ], level.hillB);

      drawHill([[width * 0.08, height * 0.43], [width * 0.15, height * 0.34], [width * 0.22, height * 0.5], [width * 0.14, height * 0.45]], '#a6dc00');
      drawHill([[width * 0.45, height * 0.4], [width * 0.53, height * 0.31], [width * 0.62, height * 0.48], [width * 0.52, height * 0.43]], '#a6dc00');
      drawHill([[width * 0.82, height * 0.42], [width * 0.88, height * 0.35], [width * 0.95, height * 0.49], [width * 0.88, height * 0.45]], '#a6dc00');

      drawTerrain(width, height);

      for (let tree = 0; tree < 8; tree += 1) {
        const treeX = width * (0.1 + tree * 0.11);
        drawPineTree(treeX, terrainY(treeX, width, height) + 9, clamp(width / 1200, 0.34, 0.72));
      }

      drawSmallBrandFlag(width, height);
      drawWind(width);
      drawMissionStamp(width, height);
      drawCanvasHud(width);

      const player = tankPosition('player');
      const enemy = tankPosition('enemy');
      const labelScale = clamp(width / 1180, 0.48, 1);
      const labelY = clamp(Math.min(player.y, enemy.y) - 88, height * 0.2, height * 0.74);

      drawPlayerLabel(clamp(player.x - 52, 16, width * 0.42), labelY, 'left', 'Player 1', '#173b74', labelScale);
      drawPlayerLabel(clamp(enemy.x + 52, width * 0.58, width - 16), labelY, 'right', 'OPPOSITION', '#a82a24', labelScale);

      drawTank(player.x, player.y, 'left', state.phase === 'player');
      drawTank(enemy.x, enemy.y, 'right', state.phase === 'enemy');

      drawProjectile();
      drawExplosion();
    }

    function weaponSettings() {
      const weapon = weaponInput ? weaponInput.value : 'volcano';
      if (weapon === 'needle') return { radius: 2, blast: 18, gravity: 760, bonus: 140, damage: 90 };
      if (weapon === 'supply') return { radius: 7, blast: 56, gravity: 350, bonus: 90, damage: 50, windMultiplier: 2.5, drawChute: true };
      return { radius: 5, blast: 0, gravity: 760, bonus: 200, damage: 0, cluster: 5 };
    }

    function currentWeapon() {
      return weaponInput ? weaponInput.value : 'volcano';
    }

    function projectileStillActive(projectile) {
      return state.projectiles.indexOf(projectile) !== -1;
    }

    function makeProjectile(options) {
      const settings = options.settings || {};
      return {
        owner: options.owner,
        groupId: options.groupId,
        startedAt: options.startedAt || Date.now(),
        x: options.x,
        y: options.y,
        vx: options.vx,
        vy: options.vy,
        radius: settings.radius,
        blast: settings.blast,
        gravity: settings.gravity,
        bonus: settings.bonus || 0,
        damage: settings.damage || 0,
        cluster: settings.cluster || 0,
        windMultiplier: settings.windMultiplier || 1,
        drawChute: Boolean(settings.drawChute),
        minFlightMs: options.minFlightMs || 140,
        trail: options.trail || [],
        weapon: options.weapon,
      };
    }

    function launchProjectile(owner, options) {
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const settings = options && options.settings ? options.settings : weaponSettings();
      const ratio = owner === 'player' ? state.tankX : state.enemyX;
      const tankX = width * ratio;
      const tankY = terrainY(tankX, width, height);
      const angle = options && options.angle ? options.angle : launchAngleFor(owner);
      const power = options && options.power ? options.power : state.power;
      const direction = owner === 'player' ? 1 : -1;
      const speed = power * 12.8;
      const groupId = state.shotSequence + 1;
      state.shotSequence = groupId;
      state.projectiles = [];

      const projectile = makeProjectile({
        owner,
        groupId,
        x: tankX + Math.cos(angle) * 28 * direction,
        y: tankY - 18 - Math.sin(angle) * 28,
        vx: Math.cos(angle) * speed * direction,
        vy: -Math.sin(angle) * speed,
        settings,
        minFlightMs: owner === 'enemy' ? 320 : 140,
        weapon: owner === 'enemy' ? 'enemy' : currentWeapon(),
      });
      state.projectiles.push(projectile);
      state.lastFrame = 0;
      syncHud();
      const launchedProjectile = projectile;
      window.setTimeout(() => {
        if (!projectileStillActive(launchedProjectile)) return;
        launchedProjectile.x = clamp(launchedProjectile.x, 0, canvas.clientWidth);
        launchedProjectile.y = canvas.clientHeight + 10;
        resolveProjectile(launchedProjectile, true);
      }, 9000);
      scheduleTick();
    }

    function applyExplosion(projectile, x, y, hitGround) {
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const blast = Math.max(0, projectile.blast || 0);
      if (!blast) return;
      const targetX = width * (projectile.owner === 'player' ? state.enemyX : state.tankX);
      const targetY = terrainY(targetX, width, height) - 14;
      const distanceToTarget = Math.hypot(x - targetX, y - targetY);
      const directHit = distanceToTarget < blast * 0.45;
      const damage = directHit ? projectile.damage : Math.max(0, Math.round((1 - distanceToTarget / blast) * projectile.damage));

      state.craters.push({
        x,
        radius: blast,
        depth: hitGround ? blast * 0.58 : blast * 0.25,
      });
      if (state.craters.length > 10) state.craters.shift();

      state.explosion = {
        x,
        y,
        radius: blast * 0.42,
        life: prefersReducedMotion ? 10 : 30,
      };

      if (damage > 0) {
        if (projectile.owner === 'player') {
          state.enemyHealth = clamp(state.enemyHealth - damage, 0, currentLevel().enemyHealth);
          state.score += projectile.bonus + damage;
          setStatus(directHit ? 'direct hit' : 'splash hit');
          setActiveCard(state.activeCard + 1);
        } else {
          state.playerHealth = clamp(state.playerHealth - damage, 0, 100);
          setStatus(directHit ? 'OPPOSITION hit' : 'OPPOSITION splash');
        }
      } else {
        setStatus(projectile.owner === 'player' ? 'missed' : 'OPPOSITION missed');
        if (projectile.owner === 'player') state.score = Math.max(0, state.score - 25);
      }

      syncHud();
    }

    function splitCluster(parent) {
      const parentIndex = state.projectiles.indexOf(parent);
      if (parentIndex === -1 || !parent.cluster) return;
      state.projectiles.splice(parentIndex, 1);
      const count = parent.cluster;
      for (let index = 0; index < count; index += 1) {
        const spread = (index - (count - 1) / 2) * 55;
        state.projectiles.push(makeProjectile({
          owner: parent.owner,
          groupId: parent.groupId,
          startedAt: parent.startedAt,
          x: parent.x,
          y: parent.y,
          vx: parent.vx * 0.4 + spread,
          vy: 60,
          settings: {
            radius: 4,
            blast: 32,
            gravity: 760,
            damage: 26,
            bonus: Math.round((parent.bonus || 0) / count),
          },
          minFlightMs: 90,
          trail: [{ x: parent.x, y: parent.y }],
          weapon: 'volcano-child',
        }));
      }
      setStatus('volcano split');
    }

    function finishShot(owner) {
      syncHud();
      checkRoundEnd(owner);
    }

    function resolveProjectile(projectile, hitGround) {
      const projectileIndex = state.projectiles.indexOf(projectile);
      if (projectileIndex === -1) return;
      state.projectiles.splice(projectileIndex, 1);

      if (projectile.blast > 0) {
        applyExplosion(
          projectile,
          clamp(projectile.x, 0, canvas.clientWidth),
          clamp(projectile.y, 0, canvas.clientHeight),
          hitGround
        );
      } else {
        setStatus(projectile.owner === 'player' ? 'missed' : 'OPPOSITION missed');
        if (projectile.owner === 'player') state.score = Math.max(0, state.score - 25);
      }

      const groupActive = state.projectiles.some((activeProjectile) => activeProjectile.groupId === projectile.groupId);
      if (!groupActive) {
        finishShot(projectile.owner);
      } else {
        syncHud();
      }
      scheduleTick();
    }

    function completeLevel() {
      const level = currentLevel();
      const finalLevel = state.level >= LEVELS.length;
      state.score += 500 + state.level * 150;
      state.phase = finalLevel ? 'won' : 'level-clear';
      setStatus(finalLevel ? 'completely AWOL' : level.clearTitle);
      syncHud();
      drawGame();

      if (state.level === 1) {
        showCelebration({
          kicker: 'Level 1 clear',
          title: 'Approaching AWOL',
          copy: level.clearCopy,
          code: freeShippingCode,
          rewardLabel: 'Take free shipping',
          canContinue: true,
          continueLabel: 'Advance',
        });
        return;
      }

      if (finalLevel) {
        showCelebration({
          kicker: 'Campaign complete',
          title: 'Completely AWOL',
          copy: level.clearCopy,
          code: finalRewardCode,
          rewardLabel: 'Take 20% off',
          canContinue: false,
          showClearance: true,
          showScores: true,
        });
        return;
      }

      showCelebration({
        kicker: 'Level ' + state.level + ' clear',
        title: level.clearTitle,
        copy: level.clearCopy,
        canContinue: true,
        continueLabel: 'Next mission',
      });
    }

    function checkRoundEnd(owner) {
      if (state.enemyHealth <= 0) {
        completeLevel();
        return;
      }

      if (state.playerHealth <= 0) {
        state.phase = 'lost';
        setStatus('OPPOSITION wins');
        syncHud();
        drawGame();
        showCelebration({
          kicker: 'Run ended',
          title: 'OPPOSITION wins',
          copy: 'Field test failed. Log the score or run it back.',
          canContinue: false,
          showScores: true,
        });
        return;
      }

      if (owner === 'player') {
        state.phase = 'enemy';
        setStatus('OPPOSITION loading');
        syncHud();
        drawGame();
        window.clearTimeout(enemyTimer);
        enemyTimer = window.setTimeout(() => {
          enemyTurn();
        }, prefersReducedMotion ? 350 : 700);
      } else {
        state.phase = 'player';
        state.wind = randomWind(currentLevel());
        setStatus('your turn');
        syncHud();
      }
    }

    function fire() {
      if (state.projectiles.length || state.phase === 'enemy' || state.phase === 'level-clear' || state.phase === 'won' || state.phase === 'lost') return;
      if (state.phase === 'ready') startRound();
      state.playing = true;
      state.phase = 'player';
      section.classList.add('is-game-live');
      state.playerShots += 1;
      setStatus('level ' + state.level + ' live');
      syncHud();
      launchProjectile('player');
    }

    function enemyTurn() {
      if (state.projectiles.length || state.phase !== 'enemy' || state.playerHealth <= 0 || state.enemyHealth <= 0) return;
      setStatus('OPPOSITION firing');
      syncHud();

      const level = currentLevel();
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const fromX = width * state.enemyX;
      const toX = width * state.tankX;
      const fromY = terrainY(fromX, width, height) - 18;
      const toY = terrainY(toX, width, height) - 18;
      const dx = Math.max(120, Math.abs(fromX - toX));
      const angle = (39 + Math.random() * level.enemySpread) * Math.PI / 180;
      const gravity = 770;
      const windDrift = state.wind * 2.2;
      const roughSpeed = Math.sqrt((dx * gravity) / Math.max(0.35, Math.sin(2 * angle)));
      const heightAdjust = clamp((fromY - toY) * 0.06, -18, 18);
      const mistake = Math.random() * level.enemySpread - level.enemySpread / 2;
      const power = clamp((roughSpeed / 12.8) + heightAdjust - windDrift + mistake, level.enemyPowerMin, level.enemyPowerMax);
      state.enemyAngle = Math.round((angle * 180) / Math.PI);
      drawGame();

      launchProjectile('enemy', {
        angle,
        power,
        settings: { radius: 6, blast: level.enemyBlast, gravity, bonus: 0, damage: level.enemyDamage },
      });
    }

    function scheduleTick() {
      if (state.raf) return;
      state.raf = window.requestAnimationFrame((frameTime) => {
        state.raf = 0;
        tick(frameTime);
      });
    }

    function tick(frameTime) {
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      if (prefersReducedMotion && state.lastFrame && frameTime - state.lastFrame < 66) {
        scheduleTick();
        return;
      }
      const delta = Math.min(0.032, ((frameTime - state.lastFrame) || 16) / 1000);
      state.lastFrame = frameTime;

      if (state.projectiles.length) {
        state.projectiles.slice().forEach((projectile) => {
          if (!projectileStillActive(projectile)) return;
          const shotAge = Date.now() - projectile.startedAt;
          const previousVy = projectile.vy;
          projectile.trail.push({ x: projectile.x, y: projectile.y });
          if (projectile.trail.length > 18) projectile.trail.shift();
          projectile.x += projectile.vx * delta;
          projectile.y += projectile.vy * delta;
          projectile.vx += state.wind * 6 * (projectile.windMultiplier || 1) * delta;
          projectile.vy += projectile.gravity * delta;

          if (projectile.cluster && previousVy < 0 && projectile.vy >= 0) {
            splitCluster(projectile);
            return;
          }

          const targetX = width * (projectile.owner === 'player' ? state.enemyX : state.tankX);
          const targetY = terrainY(targetX, width, height) - 14;
          const distanceToTarget = Math.hypot(projectile.x - targetX, projectile.y - targetY);
          const hitTarget = projectile.blast > 0 && distanceToTarget < projectile.blast * 0.45;
          const hitGround = shotAge > projectile.minFlightMs && projectile.y >= terrainY(projectile.x, width, height);
          const outOfBounds = projectile.x < -40 || projectile.x > width + 40 || projectile.y < -height * 1.5 || projectile.y > height + 40;
          const shotExpired = shotAge > 9000;

          if (hitTarget || hitGround || outOfBounds || shotExpired) {
            resolveProjectile(projectile, hitGround || projectile.y > height);
          }
        });
      }

      if (state.explosion) {
        state.explosion.life -= 1;
        state.explosion.radius += prefersReducedMotion ? 0.8 : 1.6;
        if (state.explosion.life <= 0) {
          state.explosion = null;
        }
      }

      drawGame();

      if (state.projectiles.length || state.explosion) {
        scheduleTick();
      }
    }

    function drive(direction) {
      if (state.phase === 'enemy' || state.phase === 'level-clear' || state.phase === 'won' || state.phase === 'lost' || state.projectiles.length) return;
      const change = direction === 'left' ? -0.025 : 0.025;
      state.tankX = clamp(state.tankX + change, 0.08, 0.42);
      setStatus(direction === 'left' ? 'rolling west' : 'rolling east');
      drawGame();
    }

    function aim(direction) {
      if (state.phase === 'enemy' || state.phase === 'level-clear' || state.phase === 'won' || state.phase === 'lost' || state.projectiles.length) return;
      const change = direction === 'up' ? 5 : -5;
      state.angle = clamp(state.angle + change, 10, 88);
      setStatus(direction === 'up' ? 'angle up' : 'angle down');
      syncHud();
      drawGame();
    }

    function activateGame() {
      if (state.phase === 'ready') startRound();
      section.classList.add('is-game-live');
      setStatus(state.phase === 'player' ? 'your turn' : status.textContent);
      syncHud();
      canvas.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
      drawGame();
    }

    function pointerPosition(event) {
      const rect = canvas.getBoundingClientRect();
      return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
      };
    }

    function updateAimFromPointer(point) {
      const player = tankPosition('player');
      const dx = point.x - player.x;
      const dy = player.y - 18 - point.y;
      if (dx <= 2) return;
      state.angle = clamp((Math.atan2(dy, dx) * 180) / Math.PI, 10, 88);
      state.power = clamp(Math.hypot(dx, dy) / 4, 20, 90);
      setStatus('aim adjusted');
      syncHud();
      drawGame();
    }

    canvas.addEventListener('pointerdown', (event) => {
      if (state.phase === 'enemy' || state.phase === 'level-clear' || state.phase === 'won' || state.phase === 'lost' || state.projectiles.length) return;
      const point = pointerPosition(event);
      const player = tankPosition('player');
      const distanceToTank = Math.hypot(point.x - player.x, point.y - (player.y - 20));
      if (distanceToTank > 90) return;
      state.draggingAim = true;
      canvas.setPointerCapture(event.pointerId);
      event.preventDefault();
      updateAimFromPointer(point);
    });

    canvas.addEventListener('pointermove', (event) => {
      if (!state.draggingAim) return;
      event.preventDefault();
      updateAimFromPointer(pointerPosition(event));
    });

    canvas.addEventListener('pointerup', (event) => {
      if (!state.draggingAim) return;
      state.draggingAim = false;
      canvas.releasePointerCapture(event.pointerId);
    });

    canvas.addEventListener('pointercancel', () => {
      state.draggingAim = false;
    });

    playButton && playButton.addEventListener('click', activateGame);
    startButton && startButton.addEventListener('click', activateGame);
    playAgainButton && playAgainButton.addEventListener('click', () => {
      startRound({ resetCampaign: true });
      canvas.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
    });

    highScoreForm && highScoreForm.addEventListener('submit', (event) => {
      event.preventDefault();
      saveScore(highScoreInitials ? highScoreInitials.value : 'WFS', state.score);
      renderBestScore();
      renderHighScores();
      if (highScoreForm) highScoreForm.hidden = true;
      if (highScorePlayAgain) highScorePlayAgain.hidden = false;
    });

    highScoreInitials && highScoreInitials.addEventListener('input', () => {
      highScoreInitials.value = highScoreInitials.value.replace(/[^a-z0-9]/gi, '').slice(0, 3).toUpperCase();
    });

    highScorePlayAgain && highScorePlayAgain.addEventListener('click', () => {
      startRound({ resetCampaign: true });
      canvas.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
    });

    continueButton && continueButton.addEventListener('click', () => {
      startRound({ level: state.level + 1 });
      canvas.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
    });

    rewardCopyButton && rewardCopyButton.addEventListener('click', () => {
      if (!activeRewardCode) return;
      const done = () => {
        rewardCopyButton.textContent = 'Code copied';
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(activeRewardCode).then(done).catch(() => {
          rewardCopyButton.textContent = activeRewardCode;
        });
      } else {
        rewardCopyButton.textContent = activeRewardCode;
      }
    });

    fireButtons.forEach((button) => {
      button.addEventListener('click', () => {
        fire();
      });
    });

    aimButtons.forEach((button) => {
      button.addEventListener('click', () => aim(button.dataset.awolAim));
    });

    driveButtons.forEach((button) => {
      button.addEventListener('click', () => drive(button.dataset.awolDrive));
    });

    powerInput && powerInput.addEventListener('input', () => {
      state.power = Number(powerInput.value);
      setStatus('power locked');
      syncHud();
    });

    weaponInput && weaponInput.addEventListener('change', () => {
      setStatus(weaponInput.options[weaponInput.selectedIndex].text.toLowerCase());
    });

    cards.forEach((card, index) => {
      card.addEventListener('mouseenter', () => setActiveCard(index));
      card.addEventListener('focusin', () => setActiveCard(index));
    });

    window.addEventListener('resize', fitCanvas);
    state.wind = randomWind(currentLevel());
    hideCelebration();
    syncHud();
    setActiveCard(0);
    fitCanvas();
    refreshCartCount();
  });
})();
